import { ValidationResultTuple, QuestionValidators, QuestionValidator } from '../types';

export default (
  validators: QuestionValidator[] | null,
  lastResult?: ValidationResultTuple | null
): QuestionValidators => {
  const newValidators = validators ?? [];

  return { validators: newValidators, lastResult: lastResult ?? null };
};
